import restApi from "../../http.js";
import session from "../session.js";

export default class PromoCodeApi {
  get(request) {
    return restApi({
      method: "GET",
      url: "/promo-codes",
      params: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getPromoCode(id) {
    return restApi({
      method: "GET",
      url: `/promo-codes/${id}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  create(request) {
    return restApi({
      method: "POST",
      url: "/promo-codes",
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  update(request) {
    return restApi({
      method: "PATCH",
      url: `/promo-codes/${request.id}`,
      data: request,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getPromoCodeBrands() {
    return restApi({
      method: "GET",
      url: "/promo-codes/brands",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getPromoCodeStatuses() {
    return restApi({
      method: "GET",
      url: "/promo-codes/statuses",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
